import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import styles from "../styles/Layout.module.css";
import Footer from "./Footer";
import Header from "./Header";
import Hero from "./Hero";

export default function Layout({
  title = "Chinese Horoscope Zodiac Finder",
  description = "Find your Chinese Zodiac sign by discovering which animal corresponds to your birth year",
  keywords = "chinese horoscope, zodiac finder, chinese zodiac search",
  imageUrl = null,
  children,
}) {
  const location = useLocation();

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://mychinesehoroscope.com";

  const currentUrl = `${baseUrl}${location.pathname}`;
  const defaultImageUrl = `${baseUrl}/chinese-horoscope-finder.png`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description: description,
    url: currentUrl,
    mainEntity: {
      "@type": "WebSite",
      name: "MyChineseHoroscope",
      url: baseUrl,
      potentialAction: {
        "@type": "SearchAction",
        target: `${baseUrl}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
  };

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={currentUrl} />

        {/* Favicons */}
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />

        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={imageUrl || defaultImageUrl} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={imageUrl || defaultImageUrl} />
        <meta name="twitter:url" content={currentUrl} />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <Header />
      {location.pathname === "/" && <Hero />}<div className={styles.pageWrapper}>
      <main className={styles.container}>{children}</main></div>
      <Footer />
    </div>
  );
}
